import { Observable } from 'rxjs/Observable'
import { combineEpics } from 'redux-observable'
import * as actions from './actions'
import * as OrgActions from 'modules/org/actions'
import { api } from './api'

const createNewsletterPlaybook = action$ => {
  return action$
    .ofType(actions.createNewsletterPlaybook.toString())
    .pluck('payload')
    .mergeMap((configuration) => {
      return api
        .createNewsletterPlaybook(configuration)
        .map((res) => {
          return actions.createNewsletterPlaybookSuccess(res)
        })
        .startWith(actions.createNewsletterPlaybookPending())
        .catch(() => Observable.of(actions.createNewsletterPlaybookFailed()))
    })
}

const createDemoRequestPlaybook = action$ => {
  return action$
    .ofType(actions.createDemoRequestPlaybook.toString())
    .pluck('payload')
    .mergeMap((configuration) => {
      return api
        .createDemoRequestPlaybook(configuration)
        .map((res) => {
          return actions.createDemoRequestPlaybookSuccess(res)
        })
        .startWith(actions.createDemoRequestPlaybookPending())
        .catch(() => Observable.of(actions.createDemoRequestPlaybookFailed()))
    })
}

const updateCLPSettings = action$ => {
  return action$
    .ofType(actions.updateCLPSettings.toString())
    .pluck('payload')
    .mergeMap(({playbookId, settings}) => {
      return Observable.fromPromise(api.saveLandingPageSettings(playbookId, settings))
        .map((response) => actions.updateCLPSettingsSuccess(response))
        .startWith(actions.updateCLPSettingsPending())
        .catch(() => Observable.of(actions.updateCLPSettingsFailed()))
    })
}

const fetchCLPSettings = action$ => {
  return action$
    .ofType(actions.fetchCLPSettings.toString())
    .pluck('payload')
    .mergeMap((playbookId) => {
      return Observable.fromPromise(api
        .fetchLandingPageSettings(playbookId))
        .map(actions.fetchCLPSettingsSuccess)
        .startWith(actions.fetchCLPSettingsPending)
        .catch(() => Observable.of(actions.fetchCLPSettingsFailed))
    })
}

const fetchCLPSubdomain = action$ => {
  return action$
    .ofType(actions.fetchCLPSubdomain.toString())
    .pluck('payload')
    .mergeMap(() => {
      return Observable.fromPromise(api
        .fetchLandingPageSubdomain())
        .map(actions.fetchCLPSubdomainSuccess)
        .startWith(actions.fetchCLPSubdomainPending)
        .catch(() => Observable.of(actions.fetchCLPSubdomainFailed))
    })
}

const fetchCLPCname = action$ => {
  return action$
    .ofType(actions.fetchCLPCname.toString())
    .pluck('payload')
    .mergeMap(() => {
      return Observable.fromPromise(api
        .fetchLandingPageCname())
        .map(actions.fetchCLPCnameSuccess)
        .startWith(actions.fetchCLPCnamePending)
        .catch(() => Observable.of(actions.fetchCLPCnameFailed))
    })
}

const createWelcomePlaybooks = action$ => {
  return action$
    .ofType(OrgActions.updateWelcomeMessage.toString())
    .pluck('payload')
    .mergeMap(({ onlineText, offlineText }) => {
      return api
        .createWelcomePlaybooks(onlineText, offlineText)
        .map(actions.createWelcomePlaybooksSuccess)
        .startWith(actions.createWelcomePlaybooksPending())
        .catch(() => Observable.of(actions.createWelcomePlaybooksFailed()))
    })
}

export const epic = combineEpics(
  createNewsletterPlaybook,
  createDemoRequestPlaybook,
  updateCLPSettings,
  fetchCLPSettings,
  fetchCLPSubdomain,
  fetchCLPCname,
  createWelcomePlaybooks
)


// WEBPACK FOOTER //
// ./src/modules/playbook/epic.js